import {useEffect} from 'react';
import {useFormikContext} from 'formik';
import {useSelector} from "react-redux";
import {
    selectCurrentChoosenTourData,
    selectCurrentChoosenTourDataHotels,
    selectCurrentChoosenTourDataPaymentType
} from "@src/store/ducks/orders/selectors";
import {selectUserInfo} from "@src/store/ducks/user/selectors";
import moment from "moment/moment";


export const useCostCalculationPreOrder = (vehicleType: string, data: any) => {
    const {getFieldProps, setFieldValue, values} = useFormikContext<any>();
    const user = useSelector(selectUserInfo)
    const dataTourists = getFieldProps('data.tourists');
    const chosePlace = getFieldProps('data.useFreePlaces');
    const currentChoosenTourData = useSelector(selectCurrentChoosenTourData)
    const finalFirstPartPriceByn = getFieldProps('data.finalFirstPartPriceByn').value
    const finalPriceFieldUsdFirstPartPrice = getFieldProps('data.finalPriceFieldUsdFirstPartPrice').value
    const hotels = data.trip.hotels
    const isHotel = Boolean(hotels)
    const paymentType = data.paymentType
    const currentChoosenHotel = values.data.activeHotel;

    useEffect(() => {
        let finalPriceByn = 0;
        let finalPriceUsd = 0;

        let priceUsdType5Part1 = 0;
        let priceUsdType5Part2 = 0;

        let costForPlace = 0;
        let resultingTrainKidsDiscount = 0;

        if (vehicleType === 'bus') {
            /* Суммарная цена за выбор места*/
            costForPlace = (!chosePlace.value ? dataTourists.value.length * Number(data.tour.commissionAmountPlace) : 0);
        }

        /* Суммарная комиссия с партнера*/
        let costForComission = (user.roleId === 2 ? +data.tour.commissionAmountPartner * dataTourists.value.length : 0)

        /* Стоимость выбора трехместных номеров*/
        // let costForRoomTypeTriple = dataTourists.value.reduce((accumulator:any, item:any) => {
        //     if(item.roomType === currentChoosenTourData.tripleRoomTypeAmount.id) {
        //         return accumulator + Number(currentChoosenTourData.tripleRoomTypeAmount.amount);
        //     } else {
        //         return accumulator
        //     }
        // }, 0);

        // Стоимость отелей
        let costForHotels = 0
        if (isHotel && hotels && currentChoosenHotel) {
            if (paymentType === 2) {
                costForHotels = dataTourists.value.length * Number(hotels.find((item: any) => item.id === values.data.activeHotel)?.priceBynCounted);
            } else {
                costForHotels = dataTourists.value.length * Number(hotels.find((item: any) => item.id === values.data.activeHotel)?.priceUsdCounted);
            }
        }

        /* Стоимость выбора одноместных номеров*/
        let costForRoomTypeSingle = dataTourists.value.reduce((accumulator: any, item: any) => {
            if (item.roomType === data.trip.singleRoomType.id) {
                if (paymentType === 2) {
                    return accumulator + Number(data.trip.singleRoomType.amountByn);
                } else {
                    return accumulator + Number(data.trip.singleRoomType.amount);
                }
            } else {
                return accumulator
            }
        }, 0);

        if (vehicleType !== 'bus') {
            const currentDate = moment();
            const singleDiscountAmount = Number(currentChoosenTourData.childTrainPrice) ?? 0
            /*Скидка детям младше 10 лет из рублевой части*/
            resultingTrainKidsDiscount = dataTourists.value.reduce((accumulator: number, item: any) => {

                const birthDate = moment(item.birthDate, "DD.MM.YYYY");
                const diffInYears = currentDate.diff(birthDate, 'years');
                // TODO?: add discount type: percentage or statistical value
                return diffInYears < 10 ? accumulator += singleDiscountAmount : accumulator;
            }, 0);
        }

        // finalPriceByn = +data.trip.additionalPrice * dataTourists.value.length - costForComission + costForPlace - resultingTrainKidsDiscount + (
        //     paymentType === 2
        //         ? (isHotel ? costForHotels : costForRoomTypeSingle)
        //         : 0
        // );

        /* Финальная стоимость в рублях*/
        if (paymentType === 2) {
            finalPriceByn = +data.trip.additionalPrice * dataTourists.value.length - costForComission + costForPlace - resultingTrainKidsDiscount + costForRoomTypeSingle + (isHotel ? costForHotels : 0)
        }
        if (paymentType === 3) {
            finalPriceByn = +data.trip.additionalPrice * dataTourists.value.length - costForComission + costForPlace - resultingTrainKidsDiscount
        }
        if (paymentType === 4) {
            finalPriceByn = +data.trip.additionalPrice * dataTourists.value.length - costForComission + costForPlace - resultingTrainKidsDiscount
        }
        if (paymentType === 5) {
            finalPriceByn = +data.trip.additionalPrice * dataTourists.value.length - costForComission + costForPlace - resultingTrainKidsDiscount
        }

        /* Финальная стоимость в долларах*/
        if (paymentType === 1) {
            finalPriceUsd = +data.trip.price * dataTourists.value.length
        }
        if (paymentType === 3) {
            finalPriceUsd = +data.trip.price * dataTourists.value.length + costForRoomTypeSingle + (isHotel ? costForHotels : 0)
        }
        if (paymentType === 4) {
            finalPriceUsd = +data.trip.price * dataTourists.value.length + costForRoomTypeSingle + (isHotel ? costForHotels : 0)
        }

        if (paymentType === 5) {
            finalPriceUsd = +data.trip.price * dataTourists.value.length + costForRoomTypeSingle + (isHotel ? costForHotels : 0)
            priceUsdType5Part1 = +data.trip.priceUsdType_5Part_1 * dataTourists.value.length
            priceUsdType5Part2 = +data.trip.priceUsdType_5Part_2 * dataTourists.value.length + costForRoomTypeSingle + (isHotel ? costForHotels : 0)

        }

        const currentFinalByn = values.data.finalPriceByn;
        const currentFinalUsd = values.data.finalPriceUsd;

        if (paymentType !== 1 && (currentFinalByn.value !== String(finalPriceByn) || currentFinalUsd.value !== String(finalPriceUsd))) {
            setFieldValue('data.finalPriceByn', String(finalPriceByn));
            setFieldValue('data.finalPriceUsd', String(finalPriceUsd));
            setFieldValue('data.finalFirstPartPriceByn', String(finalPriceByn));
            setFieldValue('data.finalPriceFieldUsdFirstPartPrice', String(finalPriceUsd));
            setFieldValue('data.priceUsdType5Part1', String(priceUsdType5Part1));
            setFieldValue('data.priceUsdType5Part2', String(priceUsdType5Part2));
        }
    }, [
        vehicleType,
        paymentType,
        user.roleId,
        data.trip.additionalPrice,
        data.trip.price,
        data.trip.singleRoomType?.id,
        data.trip.singleRoomType?.amount,
        data.trip.singleRoomType?.amountByn,
        currentChoosenHotel,
        hotels,
        isHotel,
        dataTourists.value,
        chosePlace.value,
        values.data.activeHotel,
    ])

    useEffect(() => {
        if (paymentType === 3) {
            let finalSecondPartPriceByn = null;

            /* Сумма первого взноса рублях*/
            finalSecondPartPriceByn = Number(getFieldProps('data.finalPriceByn').value) - Number(getFieldProps('data.finalFirstPartPriceByn').value)

            //стоимость 2 части
            setFieldValue('data.finalSecondPartPriceByn', String(finalSecondPartPriceByn));
        }
    }, [finalFirstPartPriceByn]);

    // useEffect(() => {
    //     let finalPriceFieldUsdSecondPartPrice = null;
    //     if (paymentType !== 2) {
    //         /* Сумма первого взноса в долларах*/
    //         finalPriceFieldUsdSecondPartPrice = Number(getFieldProps('data.finalPriceUsd').value) - Number(getFieldProps('data.finalPriceFieldUsdFirstPartPrice').value)
    //
    //         //стоимость 2 части
    //         if (paymentType !== 1) {
    //             setFieldValue('data.finalPriceFieldUsdSecondPartPrice', String(finalPriceFieldUsdSecondPartPrice));
    //         }
    //     }
    // }, [finalPriceFieldUsdFirstPartPrice]);
}
